export const isTrue = value => value === 'true';
